import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const WelcomeScreen = () => {
  const navigate = useNavigate();

  const handleStart = () => navigate("/auth/enter-phone");

  return (
    <div className="w-full h-full flex flex-col justify-center items-center text-center px-4">
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-black text-2xl md:text-4xl font-bold leading-relaxed"
      >
        آوای انتظارت رو فعال کن
        <br />و جایزه ببر
      </motion.h1>

      <motion.button
        onClick={handleStart}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="mt-8 bg-[#2a95db] text-white px-8 py-3 rounded-xl text-lg md:text-xl font-bold shadow-lg hover:bg-blue-600 transition"
      >
        شروع
      </motion.button>
    </div>
  );
};

export default WelcomeScreen;
